var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "height_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m169.17,324.28c-2.27-2.27-5.28-3.52-8.49-3.52s-6.22,1.25-8.48,3.51c-2.27,2.27-3.52,5.28-3.52,8.49s1.25,6.22,3.52,8.49l51.92,51.91c2.22,3.3,5.95,5.32,9.97,5.32s7.75-2.01,9.97-5.32l51.92-51.92c2.27-2.27,3.52-5.28,3.52-8.49s-1.25-6.22-3.51-8.48c-2.27-2.27-5.28-3.52-8.49-3.52s-6.22,1.25-8.49,3.52l-32.91,32.92V71.29l32.91,32.91c2.27,2.27,5.28,3.52,8.49,3.52s6.22-1.25,8.48-3.51c2.27-2.27,3.52-5.28,3.52-8.49s-1.25-6.22-3.51-8.48l-53.4-53.4c-1.34-1.34-3.01-2.36-4.8-2.94-1.03-.33-2.1-.52-3.13-.57-.18,0-.36-.01-.54-.01-.1,0-.19,0-.29,0-1.9.04-3.78.54-5.44,1.44l-.05.03-.32.11-.67.5c-.67.46-1.29.97-1.79,1.49l-53.34,53.34c-4.68,4.68-4.68,12.29,0,16.97,2.27,2.27,5.28,3.52,8.49,3.52s6.22-1.25,8.48-3.51l32.92-32.92v285.9l-32.91-32.91Z",
    style: {
      fill: "#f7f7f7"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight);
export default __webpack_public_path__ + "static/media/height.1f752e95633cae73efa8a09857d537ae.svg";
export { ForwardRef as ReactComponent };